// /**
//  * Enum con los códigos de error estándar de la API
//  */
export const ErrorCodeEnum = {
  // Errores de autenticación
  TOKEN_INVALIDO: 'TOKEN_INVALIDO',
  TOKEN_EXPIRADO: 'TOKEN_EXPIRADO',
  CREDENCIALES_INVALIDAS: 'CREDENCIALES_INVALIDAS',

  // Errores de usuarios
  USUARIO_NO_ENCONTRADO: 'USUARIO_NO_ENCONTRADO',
  USUARIO_YA_EXISTE: 'USUARIO_YA_EXISTE',
  USUARIO_INACTIVO: 'USUARIO_INACTIVO',
  CUENTA_NO_ENCONTRADA: 'CUENTA_NO_ENCONTRADA',
  USUARIO_YA_AFILIADO: 'USUARIO_YA_AFILIADO',
  PROVEEDOR_OAUTH_NO_REGISTRADO: 'PROVEEDOR_OAUTH_NO_REGISTRADO',
  DNI_ASOCIADO_A_EMPLEADO: 'DNI_ASOCIADO_A_EMPLEADO',
  DOCUMENTO_IDENTIFICACION_INVALIDO: 'DOCUMENTO_IDENTIFICACION_INVALIDO',
  EDAD_NO_VALIDA: 'EDAD_NO_VALIDA',
  FECHA_NACIMIENTO_INVALIDA: 'FECHA_NACIMIENTO_INVALIDA',
  EMAIL_NO_VALIDO: 'EMAIL_NO_VALIDO',
  CUENTA_DIGITAL_NO_ENCONTRADA: 'CUENTA_DIGITAL_NO_ENCONTRADA',
  CREDENCIAL_SOCIAL_NO_REGISTRADA: 'CREDENCIAL_SOCIAL_NO_REGISTRADA',
  CREDENCIAL_YA_EXISTE: 'CREDENCIAL_YA_EXISTE',

  // Errores de permisos
  ACCESO_DENEGADO: 'ACCESO_DENEGADO',

  // Errores de validación
  DATOS_INVALIDOS: 'DATOS_INVALIDOS',
  CAMPO_REQUERIDO: 'CAMPO_REQUERIDO',
  FORMATO_INVALIDO: 'FORMATO_INVALIDO',

  TELEFONO_YA_REGISTRADO: 'TELEFONO_YA_REGISTRADO',
  TELEFONO_NO_REGISTRADO: 'TELEFONO_NO_REGISTRADO',
  TELEFONO_NO_ASOCIADO: 'TELEFONO_NO_ASOCIADO',
  EMAIL_YA_REGISTRADO: 'EMAIL_YA_REGISTRADO',
  EMAIL_NO_REGISTRADO: 'EMAIL_NO_REGISTRADO',

  // Errores de base de datos
  ERROR_BASE_DATOS: 'ERROR_BASE_DATOS',

  // Errores de servidor
  ERROR_INTERNO: 'ERROR_INTERNO',
  SERVICIO_NO_DISPONIBLE: 'SERVICIO_NO_DISPONIBLE',
  TIMEOUT: 'TIMEOUT',

  // Errores de verificaciones
  VERIFICACION_OTP_NO_ENCONTRADA: 'VERIFICACION_OTP_NO_ENCONTRADA',
  VERIFICACION_OTP_EXPIRADA: 'VERIFICACION_OTP_EXPIRADA',
  VERIFICACION_OTP_INVALIDA: 'VERIFICACION_OTP_INVALIDA',
  TELEFONO_NO_VALIDADO: 'TELEFONO_NO_VALIDADO',

  // Errores de registro
  MODO_REGISTRO_INVALIDO: 'MODO_REGISTRO_INVALIDO',
  REPORTE_YA_EXISTE: 'REPORTE_YA_EXISTE',

  // Errores de carrito
  CARRITO_NO_ENCONTRADO: 'CARRITO_NO_ENCONTRADO',
  DETALLE_CARRITO_NO_ENCONTRADO: 'DETALLE_CARRITO_NO_ENCONTRADO',
  NO_SE_PUEDE_DECREMENTAR_LA_CANTIDAD_POR_DEBAJO_DE_1:
    'NO_SE_PUEDE_DECREMENTAR_LA_CANTIDAD_POR_DEBAJO_DE_1',

  // Errores de vehículos
  VEHICULO_NO_ENCONTRADO: 'VEHICULO_NO_ENCONTRADO',
  VEHICULO_YA_EXISTE: 'VEHICULO_YA_EXISTE',

  // Errores de afiliación
  IMAGEN_NO_PROPORCIONADA: 'IMAGEN_NO_PROPORCIONADA',
} as const;

export type ErrorCode = (typeof ErrorCodeEnum)[keyof typeof ErrorCodeEnum];
export type ErrorKey = keyof typeof ErrorCodeEnum;
